import React from "react";

// Real crypto icons from spothq/cryptocurrency-icons via jsDelivr CDN.
// Falls back to a colored letter chip for unknown codes.
const CRYPTO_CDN = "https://cdn.jsdelivr.net/gh/atomiclabs/cryptocurrency-icons@0.18.1/svg/color";
const KNOWN_CRYPTO = new Set(["USDT", "BTC", "SOL", "ETH", "BNB", "USDC", "TRX", "XRP", "DOGE", "DAI"]);

const FIAT_SYMBOLS = {
  USD: "$", EUR: "€", GBP: "£", INR: "₹", AED: "د.إ",
  PKR: "₨", BDT: "৳", JPY: "¥", CNY: "¥", CHF: "₣", CAD: "$", AUD: "$",
};

const FIAT_COLORS = {
  USD: "#1B7F3A", EUR: "#0055A4", GBP: "#4A2C82", INR: "#FF9933",
  AED: "#00563F", PKR: "#01411C", BDT: "#006A4E", JPY: "#BC002D",
};

export default function CurrencyIcon({ code, size = 20, className = "" }) {
  if (!code) return null;
  const c = code.toUpperCase();

  if (KNOWN_CRYPTO.has(c)) {
    return (
      <img
        src={`${CRYPTO_CDN}/${c.toLowerCase()}.svg`}
        alt={c}
        width={size}
        height={size}
        className={`inline-block rounded-full ${className}`}
        style={{ verticalAlign: "middle" }}
        onError={(e) => { e.currentTarget.style.display = "none"; }}
      />
    );
  }

  // Fiat / unknown — colored chip with symbol
  const bg = FIAT_COLORS[c] || "#8B6914";
  const symbol = FIAT_SYMBOLS[c] || c[0];
  return (
    <span
      className={`inline-flex items-center justify-center rounded-full font-semibold ${className}`}
      style={{
        width: size, height: size,
        background: `linear-gradient(135deg, ${bg}, ${adjust(bg, -20)})`,
        color: "white",
        fontSize: size * 0.55,
        verticalAlign: "middle",
        boxShadow: "inset 0 1px 0 rgba(255,255,255,0.35), 0 1px 3px rgba(0,0,0,0.15)",
      }}
      aria-label={c}
    >
      {symbol}
    </span>
  );
}

function adjust(hex, amt) {
  const num = parseInt(hex.slice(1), 16);
  const r = Math.max(0, Math.min(255, (num >> 16) + amt));
  const g = Math.max(0, Math.min(255, ((num >> 8) & 0xff) + amt));
  const b = Math.max(0, Math.min(255, (num & 0xff) + amt));
  return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, "0")}`;
}
